export const name = '_matic'
export const displayName = 'Polygon'
export const ticker = `${name}_MATIC`
export const displayTicker = 'POL'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'matic', // MATICNATIVE
  'polygon', // Legacy MATIC on Ethereum
  'pol_ethereum_e5c9fadc', // POL on Ethereum
  'matic_bsc_4cef25c8',
]
